var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbnailBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 505,
    viewBox: "0 0 506 505",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 505.626,
    height: 502.15,
    rx: 30,
    fill: "#C1C4DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_359",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 506,
    height: 505
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 505.626,
    height: 504.485,
    rx: 30,
    fill: "#C1C4DE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.14 26.8594C487.59 78.4654 442.211 161.373 413.456 210.304C409.855 216.433 405.468 222.36 402.111 228.57C396.81 238.375 393.097 253.415 394.465 263.998C397.664 288.728 431.044 310.455 455.631 322.107C472.986 330.331 488.113 341.758 507.424 346.996",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.708 -11.6797C451.053 58.5165 392.677 137.217 355.776 203.776C351.155 212.112 345.525 220.175 341.217 228.621C334.415 241.958 329.649 262.416 331.406 276.811C335.51 310.45 378.346 340.004 409.897 355.853C432.056 368.202 478.158 393.029 505.628 402.886",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.564 -87.5859C419.278 12.0524 366.347 98.4086 311.258 192.884C304.359 204.716 295.955 216.161 289.523 228.151C279.368 247.081 272.253 276.119 274.875 296.552C281.003 344.301 344.953 386.251 392.056 408.746C425.306 424.626 473.312 454.081 510.307 464.195",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailBackground);
export default __webpack_public_path__ + "static/media/thumbnail-background.4098fd22cf9e30fedb7a4a68c3a03355.svg";
export { ForwardRef as ReactComponent };